import { useActions } from '../providers'
import { useQuery } from '@tanstack/react-query'

export const useBrowserTabs = () => {
  const { getBrowserTabs } = useActions()
  const { data, refetch, ...rest } = useQuery({
    queryKey: ['browser-tabs'],
    queryFn: getBrowserTabs,
  })

  return { data, refetch, ...rest }
}
